"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IRectangle.js.map